import React from "react";

type Props = {
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
};

const ButtonExport: React.FC<Props> = ({ setShow }): JSX.Element => {
  return (
    <div className="flex flex-row justify-end mt-5 mb-2">
      <button
        type="button"
        className="h-12 w-48 text-sm bg-bt-white text-bt-gray-700"
        style={{
          fontStyle: "normal",
          fontWeight: 400,
        }}
        onClick={() => setShow(true)}
      >
        EXPORT
      </button>
    </div>
  );
};

export default ButtonExport;
